import styled from 'styled-components';

const ProfileContainer = styled.div`
  padding: 10px;
  margin-bottom: 20px;
  .progress-btn {
    display: flex;
    margin-bottom: 8px;
    div {
      border-radius: 0 !important;
      box-shadow: none;
      border-right: 1px solid ${({ theme }) => theme.Bg1};
      height: 10px;
      width: calc(100% / 7);
      background-color: ${({ theme }) => theme.border1};
    }
    div:nth-child(1) {
      border-top-left-radius: 4px !important;
      border-bottom-left-radius: 4px !important;
    }
    div:last-child {
      border-top-right-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    }
    .progress-green {
      background-color: #08979c;
    }
  }
  .profile-strength-container {
    color: ${({ theme }) => theme.text1};
    padding: 8px 0px 4px 0px;
    border-radius: 4px;
    margin-bottom: 8px;
    .strength-low {
      margin-left: 4px;
      color: red;
      font-weight: 500;
    }
    .strength-medium {
      margin-left: 4px;
      color: #f57f17;
      font-weight: 500;
    }
  }
  .profile-strength {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    svg {
      width: 18px;
      height: 18px;
      margin-left: 6px;
      path {
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
  .profile-strength-info {
    position: relative;
    top: 3px;
    cursor: pointer;
  }
  .profile-highlight-container {
    margin-top: 10px;
    padding: 8px;
    border-radius: 4px;
    position: relative;
  }
  .profile-contact {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: ${({ theme }) => theme.fieldText1};
    > div {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .profile-info {
    position: absolute;
    top: -65px;
    left: 18px;
    width: 100px;
    height: 100px;
    .sub-profile {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 5px solid ${({ theme }) => theme.Bg1};
      background-color: ${({ theme }) => theme.Bg1};
      object-fit: contain;
      & ~ .ant-image-mask {
        border-radius: 50%;
      }
      path {
        fill: ${({ theme }) => theme.svg2};
      }
    }
    img {
      border: 5px solid ${({ theme }) => theme.Bg1};
    }
    .edit-subprofile-icon {
      position: absolute;
      bottom: -4px;
      left: 66px;
      background-color: ${({ theme }) => theme.lightGray};
      border-radius: 50%;
      &:hover {
        background-color: ${({ theme }) => theme.lightGrayHover};
      }
      path {
        fill: ${({ theme }) => theme.fieldText1};
      }
    }
  }

  .profile-highlight {
    color: ${({ theme }) => theme.text1};
    font-size: 15px;
    margin-top: 45px;
    @media only screen and (max-width: 599px) {
      width: calc(100vw - 50px);
    }
    > div {
      margin: 2px 0;
    }
    .profile-user-container {
      display: flex;
      align-items: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: 90%;
    }
    .profile-split-dot {
      margin: 0 4px;
      color: ${({ theme }) => theme.fieldText1};
    }
    .profile-display-name {
      font-size: 16px;
      font-weight: 600;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .profile-username {
      color: ${({ theme }) => theme.fieldText1};
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .profile-highlight-edit {
      position: absolute;
      right: 4px;
      top: 49px;
      svg path {
        fill: #6c6c6c;
      }
    }
  }

  .user-follow-container {
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    font-size: 14px;
    color: ${({ theme }) => theme.fieldText1};
    .follow-action {
      color: #1976d2;
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .user-follow-item {
    display: flex;
    > div {
      &:first-child {
        margin-right: 16px;
      }
    }
  }

  .manage-resume {
    font-size: 14.5px;
    color: #1976d2;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
    svg {
      margin-left: 6px;
      width: 15px;
      height: 15px;
      path {
        fill: #1976d2;
      }
    }
  }

  .profile-popover {
    position: absolute;
    top: 3px;
    right: 5px;
    svg {
      fill: #6c6c6c;
    }
    .profile-follow-btn {
      padding: 3px 22px;
      margin-right: 6px;
    }
    .profile-user-mail {
      margin-right: 8px;
      svg {
        width: 21px;
        height: 21px;
        fill: #1976d2;
      }
    }
  }
  @media screen and (max-width: 599px) {
    .profile-user-mail {
      min-width: 35px;
      height: 35px;
      padding: 0;
      .btn-label {
        display: none;
      }
      .MuiButton-startIcon {
        margin-right: 0px;
        margin-left: 0px;
      }
      svg {
        width: 20px !important;
        height: 20px !important;
      }
    }
  }

  .tab-view {
    margin: 10px 0;
  }
  .exp-list {
    border-bottom: 1px solid ${({ theme }) => theme.border1};
    padding: 10px 0px;
    &:last-child {
      border: 0;
    }
  }
`;

const UserResumeContainer = styled.div`
  padding: 12px 8px;
  margin: 2px;
  position: relative;
  .resume-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }
  .resume-title {
    font-size: 16px;
    font-weight: 600;
  }
  .profile-upload-resume {
    width: 20px;
    height: 20px;
    padding: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.lightGrayHover};
      border-radius: 50px;
    }
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: ${({ theme }) => theme.svg1};
      }
    }
  }
  .resume-helper-text {
    font-size: 15px;
    margin-bottom: 6px;
    color: #828282;
  }
  .resume-item {
    height: 90px;
    display: flex;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.border1};
    border-radius: 8px;
    margin-bottom: 8px;
    position: relative;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .resume-content {
    display: grid;
    align-items: center;
    padding: 8px;
    width: calc(100% - 120px);
  }
  .resume-name {
    margin-top: 3px;
    font-size: 15px;
    font-weight: 600;
    color: #1976d2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
  .resume-created {
    font-size: 14px;
    color: #828282;
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .resume-action-container {
    display: flex;
    align-items: center;
    button,
    a {
      margin-right: 12px;
    }
    button {
      svg {
        width: 20px;
        height: 20px;
      }
    }
    .resume-download-icon {
      fill: ${({ theme }) => theme.svg1};
      width: 22px;
      height: 22px;
      padding: 1px;
    }
    .resume-share-icon {
      path {
        fill: ${({ theme }) => theme.svg1};
      }
      width: 18px;
      height: 18px;
      padding: 1px;
    }
    .resume-delete-icon {
      fill: #d32f2f;
    }
    .resume-checkbox-icon {
      position: absolute;
      top: 2px;
      right: 2px;
      label {
        margin-right: 0;
      }
    }
  }
`;

const ResumeType = styled.div`
  width: 65px;
  height: 90px;
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  // color: ${({ resumetype }) =>
    resumetype === 'pdf' ? '#c22321' : '#195ab9'};
  background-color: ${({ theme }) => theme.lightGray};
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UploadResumeContainer = styled.div`
  .resume-helper-text {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dropzoneContainer {
    height: 140px;
  }
  .action-btn {
    margin-top: 25px;
    display: flex;
    justify-content: flex-end;
    > button {
      margin-left: 12px;
    }
  }
`;

const ShareResumeContainer = styled.div`
  padding-top: 35px;
`;

export {
  ProfileContainer,
  UserResumeContainer,
  UploadResumeContainer,
  ResumeType,
  ShareResumeContainer,
};
